import {UseForm} from "@mantine/hooks/lib/use-form/use-form";
import {TextInput} from "@mantine/core";
import MantineSelect from "../../../Mantine.select";
import {UseFormReturnType} from "@mantine/form/lib/use-form";

export default function UnitedStates(form: UseFormReturnType<any>, disableAllFields:boolean = false) {
    return {
        display: "United States of America",
        formItems: [
            <TextInput
                disabled={disableAllFields}
                required
                placeholder="Address"
                label="Address"
                {...form.getInputProps("address1")}/>,
            <TextInput
                disabled={disableAllFields}
                placeholder="Apartment, suite, etc."
                label="Apartment, suite, etc."
                {...form.getInputProps("address2")}/>,
            <TextInput
                disabled={disableAllFields}
                required
                placeholder="City"
                label="City"
                {...form.getInputProps("city")}/>,
            <MantineSelect.State
                disabled={disableAllFields}
                label="State"
                required
                placeholder="Please select a State"
                clearable={!disableAllFields}
                searchable
                {...form.getInputProps("zone")}/>,
            <TextInput
                disabled={disableAllFields}
                required
                placeholder="Zip Code"
                label="Zip Code"
                {...form.getInputProps("postalCode")}/>
        ]
    }
}